var exports = {
  "EY": "Text__Wq_8Aj",
  "UE": "Text_1__2QYad1",
  "Nl": "Text_2__rn2A23",
};

module.exports = exports;
